import { PreviewEmailDetails } from "shared";
import { When } from "react-if";
import { useState } from "react";

import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";
import { Button } from "../../../common/Atoms/Button";
import { Card } from "../../../common/Atoms/Card";
import { Modal } from "../../../common/Atoms/Modal";
import { CustomIframe } from "../IFrame";
import { StatementPreviewPanel } from "../Modals/StatementPreviewPanel";

import { EmailPreviewDetails } from "./EmailPreviewDetails";

interface StatementEmailPreviewProps {
  /** The statement document html */
  html: string;
  emailHtml?: string;
  email?: PreviewEmailDetails;
}

/** A button opening the statement document, plus the email it would be attached to */
export function StatementEmailPreview({
  html,
  emailHtml,
  email,
}: StatementEmailPreviewProps) {
  const [showStatementModal, setShowStatementModal] = useState(false);

  return (
    <>
      <div className={ `min-h-[100px] mt-4` }>
        <Paragraph className={ `pb-2 ml-1` }>
          { `Statement Preview` }
        </Paragraph>
        <div className={ `mt-2` }>
          <Button
            onClick={ () => setShowStatementModal(true) }
            color={ `green` }
          >
            { `Open Statement Preview` }
          </Button>
        </div>

        <When condition={ !!emailHtml }>
          <div className={ `mt-4` }>
            <Paragraph className={ `pb-2 ml-1` }>
              { `Email Copy Preview` }
            </Paragraph>

            <Card className={ `rounded-md shadow-xl border-gray-100 border` }>
              <EmailPreviewDetails email={ email } />
              <CustomIframe
                style={ {
                  width: `100%`,
                  height: `100%`,
                  minHeight: `400px`,
                } }
                srcDoc={ emailHtml }
              />
            </Card>
          </div>
        </When>
      </div>

      <Modal
        title={ `Statement Preview` }
        open={ showStatementModal }
        setOpen={ () => setShowStatementModal(false) }
        width={ `xl` }
      >
        <StatementPreviewPanel html={ html } />
      </Modal>
    </>
  );
}
